import { haack, powerNose, ellipseNose } from './nose-cones.js'

export default function drawPrint (bullet, canvas) {
  //console.log('drawPrint', bullet)
  let {
    CG,
    bearingSurfaceLength,
    baseDiameter,
    boattailLength,
    boattailAngle,
    centerX,
    centerY,
    diameter,
    hybridRadius,
    hybrid,
    junctureRadius,
    tipLength,
    tipStemDiameter,
    tipStemLength,
    tipCoreLength,
    maxTipDiameter,
    meplat,
    power,
    haackC,
    jacketThickness,
    baseCavityDiameter,
    baseCavityLength,
    noseLength,
    noseCavity,
    noseType,
    radiusInches,
    drivingBands,
    drivingBandDiameter,
    length
  } = bullet
  let arc = (x1, y1, x2, y2, x3, y3) => {
    const dist = (x1, y1, x2, y2) => Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1))
    const a = dist(x1, y1, x2, y2)
    const b = dist(x1, y1, x3, y3)
    const c = dist(x2, y2, x3, y3)
    const x = (a * a + b * b - c * c) / (2 * a * b)
    if (x >= 1) {
      return 0
    } else {
      return Math.acos(x)
    }
  }

  /////////////
  if (bullet.rtr === 1) {
    hybridRadius = 0
  }

  const arcStart = arc(
    centerX, centerY,
    hybridRadius > 0 && hybrid ? hybrid.x2 : 0, diameter / 2,
    centerX, centerY + radiusInches
  )
  const arcEnd = arc(
    centerX, centerY,
    centerX, centerY + radiusInches,
    noseLength, meplat / 2
  )
  const ctx = canvas.getContext('2d')
  ctx.clearRect(0, 0, canvas.width, canvas.height)
  ctx.fillStyle = 'white'
  ctx.fillRect(0, 0, canvas.width, canvas.height)

  let scale = 1000 / length
  const x = n => n * scale + (bearingSurfaceLength + boattailLength) * scale + 250
  const y = n => n * scale + 230 + diameter / 2 * scale
  if (y(diameter / 2) + 130 > 600) {
    scale = 250 / diameter
  }

  /////////////
  let a, b, juncture, cx, cy
  if (junctureRadius > 0) {
    const boattailAngleRadians = Math.atan2((diameter - baseDiameter) / 2, boattailLength)
    const m1 = Math.tan((boattailAngleRadians / 2) - Math.PI / 2)
    const radiusZAdjust = junctureRadius * Math.sqrt(1 / (1 + m1 * m1))
    a = Math.sin(boattailAngleRadians) * radiusZAdjust
    b = Math.cos(boattailAngleRadians) * radiusZAdjust
    juncture = {
      x1: -bearingSurfaceLength - b,
      y1: diameter / 2 - a,
      x2: -bearingSurfaceLength + radiusZAdjust,
      y2: diameter / 2,
      r: junctureRadius
    }
    juncture.x3 = (juncture.x1 + juncture.x2) / 2
    juncture.y3 = (juncture.y1 + juncture.y2) / 2
    let q = Math.sqrt(Math.pow(juncture.x2-juncture.x1, 2) + Math.pow(juncture.y2-juncture.y1, 2))
    cx = juncture.x3 - Math.sqrt(juncture.r*juncture.r-Math.pow(q/2, 2))*(juncture.y1-juncture.y2)/q
    cy = juncture.y3 - Math.sqrt(juncture.r*juncture.r-Math.pow(q/2, 2))*(juncture.x2-juncture.x1)/q
  }

  /////////////

  ctx.fillStyle = '#333'
  ctx.fillRect(10, 10, canvas.width - 20, 50)
  ctx.font = '40px sans-serif';
  ctx.fillStyle = '#fff'
  ctx.fillText(`${bullet.name ? bullet.name + ' - ' : ''}${((diameter + drivingBandDiameter) * 1000).toFixed(0)} Caliber ${bullet.grains.toFixed(0)} Grain`, 40, 50)
  ctx.font = '30px Menlo,monospace';
  ctx.fillStyle = '#000'
  if (bullet.velocity < 1100) {
    ctx.fillText(`Subsonic G7 BC: ${bullet.subBC.toFixed(3)}`, 20, 660)
    ctx.fillText(`Subsonic G7 FF: ${bullet.subFF.toFixed(3)}`, 20, 700)
  } else {
    ctx.fillText(`G7 BC: ${bullet.superBC.toFixed(3)}`, 20, 660)
    ctx.fillText(`G7 FF: ${bullet.superFF.toFixed(3)}`, 20, 700)
  }
  ctx.fillText(`Rt/R:  ${(bullet.rtr || 0).toFixed(2)}`, 20, 740)
  //ctx.fillText(`Min Twist: 1:${bullet.mcdragTwistRate.toFixed(1)} / 1:${bullet.millerTwistRate.toFixed(1)} (${bullet.velocity} fps, ${bullet.altitude} fasl)`, 20, 740)
  ctx.fillText(`Min Twist: 1:${Math.min(bullet.twistRate).toFixed(1)} (${bullet.velocity} fps)`, 20, 780)
  //ctx.fillText(`Nose Transition Angle:  ${(bullet.transitionAngle || 0).toFixed(2)}`, 20, 780)

  ctx.fillText(`Velocity: ${(bullet.velocity || 0).toFixed(0)}fps`, 700, 660)
  ctx.fillText(`Target Range: ${(bullet.targetRange || 0).toFixed(0)}yd`, 700, 700)
  ctx.fillText(`Drop: ${(bullet.dropMOA || 0).toFixed(1)}moa`, 700, 740)
  ctx.fillText(`Wind Drift: ${(bullet.windMOA || 0).toFixed(2)}moa`, 700, 780)
  if (bullet.tipCoreLength > 0 && bullet.tipStemDiameter > 0) {
    ctx.fillText(`Penetration:  ${(bullet.penetration || 0).toFixed(3)}in`, 700, 620)
  }

  ctx.fillText(`I :  ${(bullet.Ix || 0).toFixed(3)}`, 1250, 620)
  ctx.fillText(`I :  ${(bullet.Iy || 0).toFixed(3)}`, 1250, 660)
  ctx.fillText(`Θ  : ${((bullet.thetaJ || 0) * (180 / Math.PI)).toFixed(3)}`, 1250, 700)
  ctx.fillText(`C :  ${(bullet.Cd || 0).toFixed(3)}`, 1250, 740)
  ctx.fillText(`C  : ${(bullet.Cma || 0).toFixed(3)}`, 1250, 780)

  ctx.font = '25px Menlo,monospace';
  ctx.fillText(` x`, 1255, 630)
  ctx.fillText(` y`, 1255, 670)
  ctx.fillText(` jα`, 1255, 710)
  ctx.fillText(` D`, 1255, 750)
  ctx.fillText(` mα`, 1255, 790)


  const drawGeometry = (stroke, fill) => {
    ctx.beginPath()
    ctx.strokeStyle = 'black'
    ctx.fillStyle = '#dfb48c'
    ctx.lineWidth = 2
    if (hybridRadius && hybrid) {
      ctx.moveTo(x(hybrid.x1), y(-hybrid.y1))
    } else {
      /* 1 */ ctx.moveTo(x(0), y(-diameter / 2))
    }
    if (junctureRadius > 0) {
      ctx.lineTo(x(juncture.x2), y(-juncture.y2))
      ctx.arc(x(cx), y(-cy), scale * junctureRadius, 1.5 * Math.PI, Math.PI * 1.5 - Math.atan2(a, b), true)
      ctx.lineTo(x(juncture.x1), y(-juncture.y1))
    } else {
      if (drivingBands === 0) {
        /* 2 */ ctx.lineTo(x(-bearingSurfaceLength), y(-diameter / 2))
      } else {
        for (let i = 1; i < drivingBands * 2; i += 2) {
          const bandLength = bearingSurfaceLength / (drivingBands * 2)
          ctx.lineTo(x(-i * bandLength), y(-diameter / 2))
          ctx.lineTo(x(-i * bandLength), y(-(diameter + drivingBandDiameter) / 2))
          ctx.lineTo(x(-(i + 1) * bandLength), y(-(diameter + drivingBandDiameter) / 2))
          ctx.lineTo(x(-(i + 1) * bandLength), y(-diameter / 2))
        }
      }
    }
      //* 2 */ ctx.lineTo(x(-bearingSurfaceLength), y(-diameter / 2))
      /* 3 */ ctx.lineTo(x(-boattailLength - bearingSurfaceLength), y(-baseDiameter / 2))
      /* 4 */ ctx.lineTo(x(-boattailLength - bearingSurfaceLength), y(baseDiameter / 2))
    if (junctureRadius > 0) {
      ctx.lineTo(x(juncture.x1), y(juncture.y1))
      ctx.arc(x(cx), y(cy), scale * junctureRadius, Math.PI / 2 + Math.atan2(a, b), Math.PI / 2, true)
      ctx.lineTo(x(juncture.x2), y(juncture.y2))
    } else {
      if (drivingBands === 0) {
        /* 5 */ ctx.lineTo(x(-bearingSurfaceLength), y(diameter / 2))
      } else {
        for (let i = drivingBands * 2 - 1; i >= 1; i -= 2) {
          const bandLength = bearingSurfaceLength / (drivingBands * 2)
          ctx.lineTo(x(-(i + 1) * bandLength), y(diameter / 2))
          ctx.lineTo(x(-(i + 1) * bandLength), y((diameter + drivingBandDiameter) / 2))
          ctx.lineTo(x(-i * bandLength), y((diameter + drivingBandDiameter) / 2))
          ctx.lineTo(x(-i * bandLength), y(diameter / 2))
        }
      }
    }
    if (hybridRadius && hybrid) {
      ctx.lineTo(x(hybrid.x1), y(hybrid.y1))
    } else {
      /* 6 */ ctx.lineTo(x(0), y(diameter / 2))
    }

    if (junctureRadius > 0) {
      ctx.moveTo(x(juncture.x1), y(juncture.y1))
      ctx.lineTo(x(juncture.x1), y(-juncture.y1))
      ctx.moveTo(x(juncture.x2), y(juncture.y2))
      ctx.lineTo(x(juncture.x2), y(-juncture.y2))
    } else {
      /* 2 */ ctx.moveTo(x(-bearingSurfaceLength), y(-diameter / 2))
      /* 5 */ ctx.lineTo(x(-bearingSurfaceLength), y(diameter / 2))
    }

    if (hybridRadius > 0 && hybrid) {
      /* 1 */ ctx.moveTo(x(hybrid.x2), y(-hybrid.y2))
      /* 6 */ ctx.lineTo(x(hybrid.x2), y(hybrid.y2))
      /* 1 */ ctx.moveTo(x(hybrid.x1), y(-hybrid.y1))
      /* 6 */ ctx.lineTo(x(hybrid.x1), y(hybrid.y1))
    } else {
      /* 1 */ ctx.moveTo(x(0), y(-diameter / 2))
      /* 6 */ ctx.lineTo(x(0), y(diameter / 2))
    }

    if (noseType === 'haack') {
      for (let i = 0; i < noseLength; i += .001) {
        const d = diameter
        const l = noseLength
        const hx = noseLength - i
        const hy = haack(d - meplat, l, hx, haackC) + meplat / 2
        ctx.lineTo(x(i), y(hy))
      }
      for (let i = noseLength; i >= 0; i -= .001) {
        const d = diameter
        const l = noseLength
        const hx = noseLength - i
        const hy = haack(d - meplat, l, hx, haackC) + meplat / 2
        ctx.lineTo(x(i), y(-hy))
      }
    } else if (noseType === 'power') {
      for (let i = 0; i < noseLength; i += .001) {
        const d = diameter
        const l = noseLength
        const hx = noseLength - i
        const hy = powerNose(d, l, hx, power)
        ctx.lineTo(x(i), y(hy))
      }
      for (let i = noseLength; i >= 0; i -= .001) {
        const d = diameter
        const l = noseLength
        const hx = noseLength - i
        const hy = powerNose(d, l, hx, power)
        ctx.lineTo(x(i), y(-hy))
      }
    } else if (noseType === 'ellipse') {
      for (let i = 0; i < noseLength; i += .001) {
        //const hy  = (diameter / 2) * Math.sqrt(1 - (Math.pow(i, 2) / Math.pow(noseLength, 2)))
        const hy = ellipseNose(diameter, noseLength, i)
        ctx.lineTo(x(i), y(hy))
      }
      for (let i = noseLength; i >= 0; i -= .001) {
        const hy  = (diameter / 2) * Math.sqrt(1 - (Math.pow(i, 2) / Math.pow(noseLength, 2)))
        ctx.lineTo(x(i), y(-hy))
      }
    } else {
      if (hybridRadius > 0 && hybrid) {
        ctx.arc(x(hybrid.cx), y(hybrid.cy), scale * hybridRadius, Math.PI / 2, Math.PI /2 - hybrid.arc, true)
      }
      if (bullet.rtr > 0) {
        ctx.arc(x(centerX), y(centerY), scale * radiusInches, Math.PI / 2 - arcStart, Math.PI / 2 - arcEnd, true)
        ctx.arc(x(centerX), y(-centerY), scale * radiusInches, Math.PI * 1.5 + arcEnd, Math.PI * 1.5 + arcStart, true)
      } else {
        ctx.lineTo(x(noseLength), y(meplat / 2))
        ctx.lineTo(x(noseLength), y(-meplat / 2))
      }
      if (hybridRadius > 0 && hybrid) {
        ctx.arc(x(hybrid.cx), y(-hybrid.cy), scale * hybridRadius, Math.PI * 1.5 + hybrid.arc, Math.PI * 1.5, true)
      }
    }
    ctx.closePath()
    fill && ctx.fill()
    stroke && ctx.stroke()
  }

  drawGeometry(false, true)

  if (jacketThickness > 0) {
    const jacketArcEnd = arc(
      centerX, centerY,
      centerX, centerY + (radiusInches - jacketThickness),
      noseLength - noseCavity, meplat / 2
    )
    const cavityArcEnd = arc(
      centerX, centerY,
      centerX, centerY + (radiusInches - jacketThickness),
      centerX + Math.sqrt((radiusInches - jacketThickness) * (radiusInches - jacketThickness) - centerY * centerY), 0
    ) - .001 // really dumb hack because a proper fix would be really hard

    ctx.beginPath()
    ctx.fillStyle = '#fff'
    if (noseCavity > noseLength) {
      ctx.lineTo(x(noseLength - noseCavity), y(diameter / 2 - jacketThickness))
    }
    ctx.arc(x(centerX), y(centerY - jacketThickness), scale * radiusInches, Math.PI / 2 - arcStart, Math.PI / 2 - cavityArcEnd, true)
    ctx.arc(x(centerX), y(-centerY + jacketThickness), scale * radiusInches, Math.PI * 1.5 + cavityArcEnd, Math.PI * 1.5 + arcStart, true)
    if (noseCavity > noseLength) {
      ctx.lineTo(x(noseLength - noseCavity), y(-diameter / 2 + jacketThickness))
    }
    ctx.closePath()
    ctx.fill()
    ctx.beginPath()

    ctx.fillStyle = '#bbb'
    ctx.strokeStyle = '#aaa'
    ctx.lineWidth = 1
    if (noseCavity < noseLength) {
      ctx.moveTo(x(0), y(-diameter / 2 + jacketThickness))
    } else {
      ctx.moveTo(x(noseLength - noseCavity), y(-diameter / 2 + jacketThickness))
    }
    ctx.lineTo(x(-bearingSurfaceLength), y(-diameter / 2 + jacketThickness))
    ctx.lineTo(x(-boattailLength - bearingSurfaceLength + jacketThickness), y(-baseDiameter / 2 + jacketThickness))
    ctx.lineTo(x(-boattailLength - bearingSurfaceLength + jacketThickness), y(baseDiameter / 2 - jacketThickness))
    if (noseCavity < noseLength) {
      ctx.lineTo(x(-bearingSurfaceLength), y(diameter / 2 - jacketThickness))
      ctx.lineTo(x(0), y(diameter / 2 - jacketThickness))
      ctx.arc(x(centerX), y(centerY - jacketThickness), scale * radiusInches, Math.PI / 2 - arcStart, Math.PI / 2 - jacketArcEnd, true)
      ctx.arc(x(centerX), y(-centerY + jacketThickness), scale * radiusInches, Math.PI * 1.5 + jacketArcEnd, Math.PI * 1.5 + arcStart, true)
    } else {
      ctx.lineTo(x(-bearingSurfaceLength), y(diameter / 2 - jacketThickness))
      ctx.lineTo(x(noseLength - noseCavity), y(diameter / 2 - jacketThickness))
      ctx.lineTo(x(noseLength - noseCavity), y(-diameter / 2 + jacketThickness))
    }
    ctx.closePath()
    ctx.fill()
    ctx.stroke()
  }

  drawGeometry(true, false)

  if (tipLength > 0) {
    ctx.fillStyle = '#555'
    ctx.strokeStyle = '#000'
    ctx.beginPath()
    ctx.moveTo(x(noseLength), y(0))
    let nys = []
    for (let i = 0; i < tipLength; i += .001) {
      let ny
      if (noseType === 'haack') {
        ny = haack(diameter - meplat, noseLength, i, haackC) + meplat / 2
      } else if (noseType === 'power') {
        ny = powerNose(diameter, noseLength, i, power)
      } else if (noseType === 'ellipse') {
        ny = (diameter / 2) * Math.sqrt(1 - (Math.pow(0, 2) / Math.pow(noseLength - i, 2)))
      } else {
        ctx.moveTo(x(noseLength), y(meplat / 2))
        ny = Math.sqrt(Math.pow(radiusInches, 2) - Math.pow(noseLength - i - centerX, 2)) + centerY
      }
      nys.push(ny)
    }
    for (let i = 0; i < nys.length; i++) {
      ctx.lineTo(x(noseLength - i * .001), y(nys[i]))
    }
    ctx.lineTo(x(noseLength - tipLength), y(tipStemDiameter / 2))
    ctx.lineTo(x(noseLength - tipLength - tipStemLength), y(tipStemDiameter / 2))
    ctx.lineTo(x(noseLength - tipLength - tipStemLength), y(-tipStemDiameter / 2))
    ctx.lineTo(x(noseLength - tipLength), y(-tipStemDiameter / 2))
    for (let i = nys.length - 1; i >= 0; i--) {
      ctx.lineTo(x(noseLength - i * .001), y(-nys[i]))
    }
    ctx.lineTo(x(noseLength), y(0))
    ctx.fill()
    ctx.stroke()
  }

  if (tipCoreLength > 0 && tipStemDiameter > 0) {
    ctx.fillStyle = '#bbb'
    ctx.strokeStyle = '#aaa'
    ctx.beginPath()
    ctx.lineTo(x(noseLength - tipLength - tipStemLength), y(tipStemDiameter / 2))
    ctx.lineTo(x(noseLength - tipLength - tipStemLength - tipCoreLength), y(tipStemDiameter / 2))
    ctx.lineTo(x(noseLength - tipLength - tipStemLength - tipCoreLength), y(-tipStemDiameter / 2))
    ctx.lineTo(x(noseLength - tipLength - tipStemLength), y(-tipStemDiameter / 2))
    ctx.fill()
    ctx.stroke()
  }

  if (baseCavityDiameter > 0 && baseCavityLength > 0) {
    ctx.fillStyle = '#fff'
    ctx.strokeStyle = '#000'
    ctx.beginPath()
    ctx.moveTo(x(-boattailLength - bearingSurfaceLength) - 2, y(-baseCavityDiameter / 2))
    ctx.lineTo(x(-boattailLength - bearingSurfaceLength + baseCavityLength), y(-baseCavityDiameter / 2))
    ctx.lineTo(x(-boattailLength - bearingSurfaceLength + baseCavityLength), y(baseCavityDiameter / 2))
    ctx.lineTo(x(-boattailLength - bearingSurfaceLength) - 2, y(baseCavityDiameter / 2))
    ctx.fill()
    ctx.stroke()
  }


  ctx.fillStyle = '#000'
  ctx.beginPath()
  ctx.arc(x(bullet.CG - length + noseLength), y(0), 15, 0, Math.PI * 2)
  ctx.fill()

  ctx.fillStyle = '#fff'
  ctx.beginPath()
  ctx.moveTo(x(bullet.CG - length + noseLength), y(0))
  ctx.arc(x(bullet.CG - length + noseLength), y(0), 13, 0, Math.PI / 2)
  ctx.fill()
  ctx.beginPath()
  ctx.moveTo(x(bullet.CG - length + noseLength), y(0))
  ctx.arc(x(bullet.CG - length + noseLength), y(0), 13, Math.PI, Math.PI * 1.5)
  ctx.fill()

  ctx.fillStyle = '#000'
  ctx.lineWidth = 1
  ctx.strokeStyle = 'black'

  drawArrow(ctx, x(-boattailLength - bearingSurfaceLength), y(-diameter / 2) - 110, x(noseLength), y(-diameter / 2) - 110)

  if (hybridRadius > 0 && junctureRadius > 0 && hybrid) {
    drawArrow(ctx, x(juncture.x2), y(-diameter / 2) - 50, x(hybrid.x1), y(-diameter / 2) - 50)
    drawArrow(ctx, x(juncture.x1), y(-diameter / 2) - 50, x(juncture.x2), y(-diameter / 2) - 50)
    drawArrow(ctx, x(juncture.x1), y(-diameter / 2) - 50, x(-bearingSurfaceLength - boattailLength), y(-diameter / 2) - 50)
    drawArrow(ctx, x(hybrid.x1), y(-diameter / 2) - 50, x(hybrid.x2), y(-diameter / 2) - 50)
    drawArrow(ctx, x(hybrid.x2), y(-diameter / 2) - 50, x(noseLength), y(-diameter / 2) - 50)
  } else if (hybridRadius > 0 && hybrid) {
    drawArrow(ctx, x(-boattailLength - bearingSurfaceLength), y(-diameter / 2) - 50, x(-bearingSurfaceLength), y(-diameter / 2) - 50)
    drawArrow(ctx, x(-bearingSurfaceLength), y(-diameter / 2) - 50, x(hybrid.x1), y(-diameter / 2) - 50)
    drawArrow(ctx, x(hybrid.x1), y(-diameter / 2) - 50, x(hybrid.x2), y(-diameter / 2) - 50)
    drawArrow(ctx, x(hybrid.x2), y(-diameter / 2) - 50, x(noseLength), y(-diameter / 2) - 50)
  } else if (junctureRadius > 0) {
    drawArrow(ctx, x(juncture.x2), y(-diameter / 2) - 50, x(0), y(-diameter / 2) - 50)
    drawArrow(ctx, x(juncture.x1), y(-diameter / 2) - 50, x(juncture.x2), y(-diameter / 2) - 50)
    drawArrow(ctx, x(juncture.x1), y(-diameter / 2) - 50, x(-bearingSurfaceLength - boattailLength), y(-diameter / 2) - 50)
    drawArrow(ctx, x(0), y(-diameter / 2) - 50, x(noseLength), y(-diameter / 2) - 50)
  } else {
    drawArrow(ctx, x(-boattailLength - bearingSurfaceLength), y(-diameter / 2) - 50, x(-bearingSurfaceLength), y(-diameter / 2) - 50)
    drawArrow(ctx, x(-bearingSurfaceLength), y(-diameter / 2) - 50, x(0), y(-diameter / 2) - 50)
    drawArrow(ctx, x(0), y(-diameter / 2) - 50, x(noseLength), y(-diameter / 2) - 50)
  }
  ctx.beginPath()
  ctx.moveTo(x(-boattailLength - bearingSurfaceLength), y(-diameter / 2) - 30)
  ctx.lineTo(x(-boattailLength - bearingSurfaceLength), y(-diameter / 2) - 130)
  if (hybridRadius > 0 && junctureRadius > 0 && hybrid) {
    ctx.moveTo(x(juncture.x1), y(-diameter / 2) - 30)
    ctx.lineTo(x(juncture.x1), y(-diameter / 2) - 70)
    ctx.moveTo(x(juncture.x2), y(-diameter / 2) - 30)
    ctx.lineTo(x(juncture.x2), y(-diameter / 2) - 70)
    ctx.moveTo(x(hybrid.x1), y(-diameter / 2) - 30)
    ctx.lineTo(x(hybrid.x1), y(-diameter / 2) - 70)
    ctx.moveTo(x(hybrid.x2), y(-diameter / 2) - 30)
    ctx.lineTo(x(hybrid.x2), y(-diameter / 2) - 70)
  } else if (hybridRadius > 0 && hybrid) {
    ctx.moveTo(x(-bearingSurfaceLength), y(-diameter / 2) - 30)
    ctx.lineTo(x(-bearingSurfaceLength), y(-diameter / 2) - 70)
    ctx.moveTo(x(hybrid.x1), y(-diameter / 2) - 30)
    ctx.lineTo(x(hybrid.x1), y(-diameter / 2) - 70)
    ctx.moveTo(x(hybrid.x2), y(-diameter / 2) - 30)
    ctx.lineTo(x(hybrid.x2), y(-diameter / 2) - 70)
  } else if (junctureRadius > 0) {
    ctx.moveTo(x(juncture.x1), y(-diameter / 2) - 30)
    ctx.lineTo(x(juncture.x1), y(-diameter / 2) - 70)
    ctx.moveTo(x(juncture.x2), y(-diameter / 2) - 30)
    ctx.lineTo(x(juncture.x2), y(-diameter / 2) - 70)
    ctx.moveTo(x(0), y(-diameter / 2) - 30)
    ctx.lineTo(x(0), y(-diameter / 2) - 70)
  } else {
    ctx.moveTo(x(-bearingSurfaceLength), y(-diameter / 2) - 30)
    ctx.lineTo(x(-bearingSurfaceLength), y(-diameter / 2) - 70)
    ctx.moveTo(x(0), y(-diameter / 2) - 30)
    ctx.lineTo(x(0), y(-diameter / 2) - 70)
  }
  ctx.moveTo(x(noseLength), y(-diameter / 2) - 30)
  ctx.lineTo(x(noseLength), y(-diameter / 2) - 130)
  ctx.stroke()

  drawArrow(ctx, x(-boattailLength - bearingSurfaceLength), y(diameter / 2) + 100, x(CG - length + noseLength), y(diameter / 2) + 100)
  ctx.beginPath()
  ctx.moveTo(x(-boattailLength - bearingSurfaceLength), y(diameter / 2) + 80)
  ctx.lineTo(x(-boattailLength - bearingSurfaceLength), y(diameter / 2) + 120)
  ctx.moveTo(x(CG - length + noseLength), y(diameter / 2) + 80)
  ctx.lineTo(x(CG - length + noseLength), y(diameter / 2) + 120)
  ctx.stroke()

  drawArrow(ctx, x(-boattailLength - bearingSurfaceLength) - 50, y(-baseDiameter / 2), x(-boattailLength - bearingSurfaceLength) - 50, y(baseDiameter / 2))
  ctx.beginPath()
  ctx.moveTo(x(-boattailLength - bearingSurfaceLength) - 60, y(-baseDiameter / 2))
  ctx.lineTo(x(-boattailLength - bearingSurfaceLength) - 40, y(-baseDiameter / 2))
  ctx.moveTo(x(-boattailLength - bearingSurfaceLength) - 60, y(baseDiameter / 2))
  ctx.lineTo(x(-boattailLength - bearingSurfaceLength) - 40, y(baseDiameter / 2))
  ctx.stroke()

  if (baseCavityDiameter > 0 && baseCavityLength > 0) {
    drawArrow(ctx, x(-boattailLength - bearingSurfaceLength) + 25, y(-baseCavityDiameter / 2), x(-boattailLength - bearingSurfaceLength) + 25, y(baseCavityDiameter / 2))

    drawArrow(ctx, x(-boattailLength - bearingSurfaceLength), y(diameter / 2) + 50, x(-boattailLength - bearingSurfaceLength + baseCavityLength), y(diameter / 2) + 50)
    ctx.beginPath()
    ctx.moveTo(x(-boattailLength - bearingSurfaceLength), y(diameter / 2) + 30)
    ctx.lineTo(x(-boattailLength - bearingSurfaceLength), y(diameter / 2) + 70)
    ctx.moveTo(x(-boattailLength - bearingSurfaceLength + baseCavityLength), y(diameter / 2) + 30)
    ctx.lineTo(x(-boattailLength - bearingSurfaceLength + baseCavityLength), y(diameter / 2) + 70)
    ctx.stroke()
  }

  if (tipLength > 0) {
    drawArrow(ctx, x(noseLength - tipLength), y(diameter / 2) + 25, x(noseLength), y(diameter / 2) + 25)
    drawArrow(ctx, x(noseLength - tipLength - tipStemLength), y(diameter / 2) + 25, x(noseLength - tipLength), y(diameter / 2) + 25)
    drawArrow(ctx, x(noseLength - tipLength - tipStemLength) - 35, y(tipStemDiameter / 2), x(noseLength - tipLength - tipStemLength) - 35, y(-tipStemDiameter / 2))
    if (maxTipDiameter !== tipStemDiameter) {
      drawArrow(ctx, x(noseLength - tipLength) + 60, y(-maxTipDiameter / 2), x(noseLength - tipLength) + 60, y(-maxTipDiameter / 2) - 40, false)
      drawArrow(ctx, x(noseLength - tipLength) + 60, y(maxTipDiameter / 2), x(noseLength - tipLength) + 60, y(maxTipDiameter / 2) + 40, false)
    }
    ctx.beginPath()
    ctx.moveTo(x(noseLength - tipLength), y(diameter / 2) + 10)
    ctx.lineTo(x(noseLength - tipLength), y(diameter / 2) + 40)
    ctx.moveTo(x(noseLength - tipLength - tipStemLength), y(diameter / 2) + 10)
    ctx.lineTo(x(noseLength - tipLength - tipStemLength), y(diameter / 2) + 40)
    ctx.moveTo(x(noseLength), y(diameter / 2) + 10)
    ctx.lineTo(x(noseLength), y(diameter / 2) + 40)

    ctx.moveTo(x(noseLength - tipLength - tipStemLength) - 20, y(tipStemDiameter / 2))
    ctx.lineTo(x(noseLength - tipLength - tipStemLength) - 50, y(tipStemDiameter / 2))
    ctx.moveTo(x(noseLength - tipLength - tipStemLength) - 20, y(-tipStemDiameter / 2))
    ctx.lineTo(x(noseLength - tipLength - tipStemLength) - 50, y(-tipStemDiameter / 2))

    if (maxTipDiameter !== tipStemDiameter) {
      ctx.moveTo(x(noseLength - tipLength) + 50, y(maxTipDiameter / 2))
      ctx.lineTo(x(noseLength - tipLength) + 70, y(maxTipDiameter / 2))
      ctx.moveTo(x(noseLength - tipLength) + 50, y(-maxTipDiameter / 2))
      ctx.lineTo(x(noseLength - tipLength) + 70, y(-maxTipDiameter / 2))
    }

    ctx.stroke()
  }

  ctx.beginPath()
  if (junctureRadius > 0) {
    ctx.moveTo(x(juncture.x1) - 10, y(diameter / 2))
  } else {
    ctx.moveTo(x(-bearingSurfaceLength), y(diameter / 2))
  }
  ctx.lineTo(x(-boattailLength - bearingSurfaceLength), y(diameter / 2))
  ctx.stroke()
  drawArrow(
    ctx,
    x(-bearingSurfaceLength - boattailLength / 2),
    y(baseDiameter / 2 + (diameter - baseDiameter) / 4) - 3,
    x(-bearingSurfaceLength - boattailLength / 2),
    y(baseDiameter / 2 + (diameter - baseDiameter) / 2) - 30,
    false
  )
  drawArrow(
    ctx,
    x(-bearingSurfaceLength - boattailLength / 2),
    y(diameter / 2) + 3,
    x(-bearingSurfaceLength - boattailLength / 2),
    y(diameter / 2) + 30,
    false
  )

  if (noseType === 'secant') {
    // meplat
    ctx.beginPath()
    ctx.moveTo(x(noseLength) + 50, y(-meplat / 2))
    ctx.lineTo(x(noseLength) + 30, y(-meplat / 2))
    ctx.moveTo(x(noseLength) + 50, y( meplat / 2))
    ctx.lineTo(x(noseLength) + 30, y( meplat / 2))
    ctx.stroke()
    if (y(meplat / 2) - y(-meplat / 2) < 40) {
      drawArrow(ctx, x(noseLength) + 40, y(-meplat / 2), x(noseLength) + 40, y(-meplat / 2) - 30, false)
      drawArrow(ctx, x(noseLength) + 40, y(meplat / 2), x(noseLength) + 40, y(meplat / 2) + 30, false)
    } else {
      drawArrow(ctx, x(noseLength) + 40, y(-meplat / 2), x(noseLength) + 40, y(meplat / 2))
    }
  }

  let rx = noseLength / 2
  let ry = -(Math.sqrt(Math.pow(radiusInches, 2) - (rx - centerX) * (rx - centerX)) + centerY)
  const dist = Math.sqrt(Math.pow(rx - centerX, 2) + Math.pow(ry - centerY, 2))
  const rise = (ry - centerY) / dist
  const run = (rx - centerX) / dist
  let rx1 = rx - run * diameter * .01
  let ry1 = ry + rise * diameter * .01
  let rx2 = rx - run * diameter * 1.2
  let ry2 = ry + rise * diameter * 1.2
  if (bullet.rtr > 0) {
    drawArrow(ctx, x(rx1), y(ry1), x(rx2), y(ry2), false)
  }



  if (hybridRadius > 0 && hybrid) {
    let rx = 0
    let ry = -(Math.sqrt(Math.pow(hybridRadius, 2) - (rx - hybrid.cx) * (rx - hybrid.cx)) + hybrid.cy)
    const dist = Math.sqrt(Math.pow(rx - hybrid.cx, 2) + Math.pow(ry - hybrid.cy, 2))
    const rise = (ry - hybrid.cy) / dist
    const run = (rx - hybrid.cx) / dist
    let rx1 = rx - run * diameter * .01
    let ry1 = ry + rise * diameter * .01
    let rx2 = rx - run * diameter * 1.2
    let ry2 = ry + rise * diameter * 1.2
    hybrid.rx2 = rx2
    hybrid.ry2 = ry2
    drawArrow(ctx, x(rx1), y(ry1), x(rx2), y(ry2), false)
  }

  if (junctureRadius > 0) {
    let rx = -bearingSurfaceLength
    let ry = -(Math.sqrt(Math.pow(junctureRadius, 2) - (rx - cx) * (rx - cx)) + cy)
    const dist = Math.sqrt(Math.pow(rx - cx, 2) + Math.pow(ry - cy, 2))
    const rise = (ry - cy) / dist
    const run = (rx - cx) / dist
    let rx1 = rx - run * diameter * .01
    let ry1 = ry + rise * diameter * .01
    let rx2 = rx - run * diameter * 1.2
    let ry2 = ry + rise * diameter * 1.2
    juncture.rx2 = rx2
    juncture.ry2 = ry2
    drawArrow(ctx, x(rx1), y(ry1), x(rx2), y(ry2), false)
  }



  ctx.font = '14px monospace';
  ctx.fillText((length || 0).toFixed(3), x(0) - 28, y(-diameter / 2) - 120)
  if (junctureRadius > 0 && hybridRadius > 0 && hybrid) {
    const a = -juncture.x2 + hybrid.x1
    const b = juncture.x2 - juncture.x1
    const c = bearingSurfaceLength + boattailLength - a - b
    ctx.fillText(a.toFixed(3), x(-a / 2 + hybrid.x1) - 28, y(-diameter / 2) - 60)
    ctx.fillText(b.toFixed(3), x((juncture.x1 + juncture.x2) / 2) - 28, y(-diameter / 2) - 60)
    ctx.fillText(c.toFixed(3), x(-a - b - c/2) - 28, y(-diameter / 2) - 60)
    ctx.fillText((noseLength - hybrid.x2).toFixed(3), x((noseLength - hybrid.x2) / 2 + hybrid.x2) - 28, y(-diameter / 2) - 60)
    ctx.fillText((hybrid.x2 - hybrid.x1).toFixed(3), x(hybrid.x2 / 2) - 28, y(-diameter / 2) - 60)
  } else if (hybridRadius > 0 && hybrid) {
    const a = hybrid.x2 - hybrid.x1
    const b = bearingSurfaceLength + hybrid.x1
    ctx.fillText(a.toFixed(3), x(hybrid.x2 / 2) - 28, y(-diameter / 2) - 60)
    ctx.fillText(b.toFixed(3), x(-(bearingSurfaceLength + hybrid.x1) / 2 + hybrid.x1) - 28, y(-diameter / 2) - 60)
    ctx.fillText((boattailLength || 0).toFixed(3), x(-bearingSurfaceLength - boattailLength / 2) - 28, y(-diameter / 2) - 60)
    ctx.fillText((noseLength - hybrid.x2).toFixed(3), x((noseLength + bearingSurfaceLength - a - b) / 2 + hybrid.x2) - 28, y(-diameter / 2) - 60)
  } else if (junctureRadius > 0) {
    const a = -juncture.x2
    const b = juncture.x2 - juncture.x1
    const c = bearingSurfaceLength + boattailLength - a - b
    ctx.fillText(a.toFixed(3), x(-a / 2) - 28, y(-diameter / 2) - 60)
    ctx.fillText(b.toFixed(3), x((juncture.x1 + juncture.x2) / 2) - 28, y(-diameter / 2) - 60)
    ctx.fillText(c.toFixed(3), x(-a - b - c/2) - 28, y(-diameter / 2) - 60)
    ctx.fillText((noseLength || 0).toFixed(3), x(noseLength / 2) - 28, y(-diameter / 2) - 60)
  } else {
    ctx.fillText((boattailLength || 0).toFixed(3), x(-bearingSurfaceLength - boattailLength / 2) - 28, y(-diameter / 2) - 60)
    ctx.fillText((bearingSurfaceLength || 0).toFixed(3), x(-bearingSurfaceLength / 2) - 28, y(-diameter / 2) - 60)
    ctx.fillText((noseLength || 0).toFixed(3), x(noseLength / 2) - 28, y(-diameter / 2) - 60)
  }
  ctx.fillText((baseDiameter || 0).toFixed(3), x(-bearingSurfaceLength - boattailLength) - 100, y(0))
  if (baseCavityLength > 0 && baseCavityDiameter > 0) {
    ctx.fillText(baseCavityDiameter.toFixed(3), x(-bearingSurfaceLength - boattailLength) + 35, y(0) + 5)
    ctx.fillText(
      baseCavityLength.toFixed(3),
      x(-bearingSurfaceLength - boattailLength + baseCavityLength / 2) - 28,
      y(diameter / 2) + 70
    )
  }
  if (tipLength > 0) {
    ctx.fillText((tipLength || 0).toFixed(3), x(noseLength - tipLength / 2) - 28, y(diameter / 2) + 45)
    ctx.fillText((tipStemLength || 0).toFixed(3), x(noseLength - tipLength - tipStemLength / 2) - 28, y(diameter / 2) + 45)
    ctx.fillText((tipStemDiameter || 0).toFixed(3), x(noseLength - tipLength - tipStemLength) - 85, y(0) + 4)
    if (maxTipDiameter !== tipStemDiameter) {
      ctx.fillText((maxTipDiameter || 0).toFixed(3), x(noseLength - tipLength) + 70, y(-maxTipDiameter / 2) - 20)
    }
  }
  ctx.fillText((boattailAngle || 0).toFixed(1) + '°', x(-bearingSurfaceLength - boattailLength / 2) - 12, y(baseDiameter / 2 + (diameter - baseDiameter) / 2) - 40)
  ctx.fillText(
    `${(CG || 0).toFixed(3)} (${(100 * ((bullet.CG) / bullet.length)).toFixed(1)}%)`,
    x(-(CG) / 2) - 90,
    y(diameter / 2) + 130
  )
  if (junctureRadius > 0) {
    ctx.fillText('R' + junctureRadius.toFixed(3), x(juncture.rx2) - 24, y(juncture.ry2) + 15)
  }
  if (hybridRadius > 0 && hybrid) {
    ctx.fillText('R' + hybridRadius.toFixed(3), x(hybrid.rx2) - 24, y(hybrid.ry2) + 15)
  }
  if (noseType === 'secant') {
    ctx.fillText((meplat || 0).toFixed(3), x(noseLength) + 70, y(0) + 4)
    if (bullet.rtr > 0) {
      ctx.fillText('R ' + (radiusInches || 0).toFixed(3), x(rx2) - 24, y(ry2) + 15)
    }
  } else if (noseType === 'haack') {
    if (haackC === 0) {
      ctx.fillText('LD-Haack', x(rx2) - 24, y(ry2) + 15)
    } else {
      ctx.fillText(`Haack C=${haackC.toFixed(2)}`, x(rx2) - 24, y(ry2) + 15)
    }
  } else if (noseType === 'power') {
    ctx.fillText(power.toFixed(2) + ' Power', x(rx2) - 24, y(ry2) + 15)
  } else if (noseType === 'ellipse') {
    ctx.fillText('Ellipse', x(rx2) - 24, y(ry2) + 15)
  }
  if (hybridRadius > 0 && hybrid) {
    ctx.fillText((hybrid.y2 * 2).toFixed(3), x(hybrid.x2) + 10, y(0))
  }

  if (drivingBands === 0) {
    drawArrow(ctx, x(-bearingSurfaceLength / 2), y(diameter / 2), x(-bearingSurfaceLength / 2), y(-diameter / 2))
    ctx.fillText((diameter || 0).toFixed(3), x(-bearingSurfaceLength / 2) + 10, y(diameter / 3))
  } else {
    let x1, x2
    switch (drivingBands) {
      case 1:
      case 5:
        x1 = -bearingSurfaceLength * .25
        x2 = -bearingSurfaceLength * .75
        break
      case 2:
        x1 = -bearingSurfaceLength * .7
        x2 = -bearingSurfaceLength * .3
        break
      case 3:
        x1 = -bearingSurfaceLength * .75
        x2 = -bearingSurfaceLength * .25
        break
      case 4:
        x1 = -bearingSurfaceLength * .3125
        x2 = -bearingSurfaceLength * .6875
        break
      case 6:
        x1 = -bearingSurfaceLength * .375
        x2 = -bearingSurfaceLength * .792
        break
      default:
        x1 = -bearingSurfaceLength * .25
        x2 = -bearingSurfaceLength * .75
        break
    }
    drawArrow(ctx, x(x1), y(diameter / 2), x(x1), y(-diameter / 2))
    drawArrow(ctx, x(x2), y((diameter + drivingBandDiameter) / 2), x(x2), y(-(diameter + drivingBandDiameter) / 2))
    ctx.fillText((diameter || 0).toFixed(3), x(x1) + 10, y(0))
    ctx.fillText(((diameter + drivingBandDiameter) || 0).toFixed(3), x(x2) + 10, y(0))

    const bandLength = bearingSurfaceLength / (drivingBands * 2)
    ctx.beginPath()
    ctx.moveTo(x(-bearingSurfaceLength), y(diameter / 2) + 30)
    ctx.lineTo(x(-bearingSurfaceLength), y(diameter / 2) + 70)
    ctx.moveTo(x(-bearingSurfaceLength + bandLength), y(diameter / 2) + 30)
    ctx.lineTo(x(-bearingSurfaceLength + bandLength), y(diameter / 2) + 70)
    ctx.stroke()
    drawArrow(ctx,
      x(-bearingSurfaceLength + bandLength),
      y(diameter / 2) + 50,
      x(-bearingSurfaceLength),
      y(diameter / 2) + 50
    )
    ctx.fillText((bandLength || 0).toFixed(3), x(-bearingSurfaceLength + bandLength / 2) - 20, y(diameter / 2) + 70)
  }
}

function drawArrow (context, fromx, fromy, tox, toy, start = true, end = true) {
  let headlen = 10 // length of head in pixels
  let dx = tox - fromx
  let dy = toy - fromy
  let angle = Math.atan2(dy, dx)
  context.beginPath()
  context.moveTo(fromx, fromy)
  context.lineTo(tox, toy)
  context.stroke()
  if (start) {
    context.beginPath()
    context.moveTo(tox, toy)
    context.lineTo(tox - headlen * Math.cos(angle - Math.PI / 8), toy - headlen * Math.sin(angle - Math.PI / 8))
    context.lineTo(tox - headlen * Math.cos(angle + Math.PI / 8), toy - headlen * Math.sin(angle + Math.PI / 8))
    context.lineTo(tox, toy)
    context.fill()
  }
  if (end) {
    context.beginPath()
    context.moveTo(fromx, fromy)
    context.lineTo(fromx + headlen * Math.cos(angle - Math.PI / 8), fromy + headlen * Math.sin(angle - Math.PI / 8))
    context.lineTo(fromx + headlen * Math.cos(angle + Math.PI / 8), fromy + headlen * Math.sin(angle + Math.PI / 8))
    context.lineTo(fromx, fromy)
    context.fill()
  }
}
